import '../styles/Footer.css';
import React from 'react';

function Footer() {
  return (
    <footer className="site-footer" aria-label="Portfolio footer">
      <svg
        className="site-footer__arc"
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M0,72 Q720,8 1440,72" />
      </svg>
      <div className="site-footer__inner" data-content-rail="primary">
        <p className="site-footer__wordmark">
          <span className="site-footer__rule" aria-hidden="true" />
          <span>Umang Suthar</span>
        </p>
        <p className="site-footer__context">Full Stack Developer · Portfolio</p>
      </div>
    </footer>
  );
}

export default Footer;